import { render, staticRenderFns } from "./eventsCheck.vue?vue&type=template&id=72d77759&"
import script from "./eventsCheck.vue?vue&type=script&lang=js&"
export * from "./eventsCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports